import styled from "styled-components";
import { Device } from "../../../../styles/screenSizes";
import { colors } from "../../../../styles/variables";

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 5px;

  @media ${Device.mobile} {
    background-color: ${colors.white};
    border-bottom: 1px solid ${colors.gray200};
    height: 60px;
    padding-left: 20px;
  }
`;

export const StyledLocationText = styled.span`
  text-decoration: underline;
  font-size: 14px;
  @media ${Device.notMobile} {
    color: ${colors.white};
  }
`;
